import {Component} from '@angular/core';

@Component({
  selector: 'app-datenschutz',
  templateUrl: './datenschutz.component.html'
})
export class DatenschutzComponent {

}
